import green from '@mui/material/colors/green';
import orange from '@mui/material/colors/orange';
import red from '@mui/material/colors/red';
import {
  CheckCircle,
  EventAvailable,
  Voicemail,
  PhoneDisabled,
  Error,
  EventRepeat,
  SentimentVeryDissatisfied,
  Block,
  Comment,
  Report,
  SwapHoriz,
  EventBusy
} from '@mui/icons-material';
import {
  REPONDEUR,
  AUTRE,
  TOLISTEN,
  OK,
  RDVCONFIRMED,
  ECHECMER,
  VOL,
  MAUVAISE_PRESTATION,
  ECHANGE_NUM,
  PLATEFORME,
  CANCELRISK,
  DECALAGE,
  SEVERITY
} from '@lba-dev/package.local-globals/callTypes';

// Sévérité -> couleur MUI (objets, requis par GenTooltipIcon)
export const SEVERITY_COLOR = {
  [SEVERITY.success]: green,
  [SEVERITY.warning]: orange,
  [SEVERITY.danger]: red,
  [SEVERITY.pending]: orange,
  [SEVERITY.none]: red,
};

// Type d'appel -> icône MUI du badge
export const TYPE_ICON = {
  [OK]: CheckCircle,
  [RDVCONFIRMED]: EventAvailable,
  [REPONDEUR]: Voicemail,
  [ECHECMER]: PhoneDisabled,
  [TOLISTEN]: Error,
  [VOL]: Report,
  [MAUVAISE_PRESTATION]: SentimentVeryDissatisfied,
  [ECHANGE_NUM]: SwapHoriz,
  [PLATEFORME]: Block,
  [AUTRE]: Comment,
  [CANCELRISK]: EventBusy,
  [DECALAGE]: EventRepeat,
};
